import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "app-analytics-box",
  templateUrl: "./app-analytics-box.component.html",
  styleUrls: ["./app-analytics-box.component.scss"],
})
export class AppAnalyticsBoxComponent implements OnChanges {
  @Input() data = [];
  @Input() type: string;
  @Input() action: string;
  @Input() answer: string;
  @Input() external: boolean;
  public ofType = "";
  public type_label = "";
  public limit = 5;
  public more_label = "+ More";
  public action_label = "";

  constructor() {}

  get showUsersCount(): boolean {
    return (
      [
        "view_job",
        "view_jobs",
        "view_poll",
        "view_polls",
        "action_post",
        "action_posts",
      ].indexOf(this.action) === -1
    );
  }

  ngOnChanges() {
    switch (this.type) {
      case "faculties":
        this.type_label = "Faculty";
        this.ofType = "of";
        break;
      case "universities":
        this.type_label = "University";
        this.ofType = "of";
        break;
      case "cities":
        this.type_label = "City";
        this.ofType = "from";
        break;
      case "study_tags":
        this.type_label = "Study Area";
        this.ofType = "of";
        this.type = "faculties";
        break;
    }
    switch (this.action) {
      case "webinar_participation":
        this.action_label = "attended the experience";
        break;
      case "action_job":
        if (this.external) {
          this.action_label = "clicked";
        } else {
          this.action_label = "sent an application";
        }
        break;
      case "view_job":
        this.action_label = "viewed this job offer";
        break;
      case "view_jobs":
        this.action_label = "viewed a job offer";
        break;

      case "action_poll":
        {
          this.action_label = "answered this poll";
          if (this.answer) {
            this.action_label = 'answered "' + this.answer["answer"] + '"';
          }
        }
        break;
      case "action_polls":
        this.action_label = "answered a poll";
        break;
      case "view_poll":
        this.action_label = "viewed this poll";
        break;
      case "view_polls":
        this.action_label = "viewed a poll";
        break;

      case "action_post":
        this.action_label = "viewed this post";
        break;
      case "action_posts":
        this.action_label = "viewed an article";
        break;
      case "view_post": {
        this.action_label = " reached by the article";
        if (this.data[0] === 1) {
          this.action_label = "was reached by the article";
        }
        break;
      }
      case "view_posts": {
        this.action_label = " reached by an article";
        if (this.data[0] === 1) {
          this.action_label = " reached by an article";
        }
        break;
      }
    }
  }

  more() {
    if (this.limit === 5) {
      this.limit = 20;
      this.more_label = "-";
    } else {
      this.limit = 5;
      this.more_label = "+ More";
    }
  }
}
